module.exports = __webpack_public_path__ + "assets/img/steam-yuyue-hover-82a01cca.png";